module.exports = __webpack_public_path__ + "img/bj.7c039ba5.jpg";